import { Controller } from "@hotwired/stimulus"

// Manages the Cancel Membership modal with selectable cards:
// - now: date hidden, always valid
// - future: date shown, required for valid
// Fee section: when checkbox checked, amount required
export default class extends Controller {
  static targets = ["modeRadio", "billingRadio", "dateSection", "dateInput", "dateError", "feeCheckbox", "feeAmountSection", "feeAmountInput", "submitBtn"]
  static values = { defaultDate: String }

  connect() {
    this.toggle()
    this.toggleFeeSection()
    this.validate()
  }

  toggle() {
    const mode = this.selectedMode
    const showDate = mode === "future"
    if (this.hasDateSectionTarget) {
      this.dateSectionTarget.classList.toggle("hidden", !showDate)
    }
    if (this.hasDateInputTarget) {
      this.dateInputTarget.disabled = !showDate
      if (showDate && !this.dateInputTarget.value) {
        // Prefer the account's default notice date; fall back to the min (tomorrow).
        this.dateInputTarget.value = this.defaultDateValue || this.dateInputTarget.min || ""
      } else if (!showDate) {
        this.dateInputTarget.value = ""
      }
    }
    this.validate()
  }

  toggleFeeSection() {
    const chargeFee = this.hasFeeCheckboxTarget && this.feeCheckboxTarget.checked
    if (this.hasFeeAmountSectionTarget) {
      this.feeAmountSectionTarget.classList.toggle("hidden", !chargeFee)
    }
    this.validate()
  }

  validate() {
    if (!this.hasSubmitBtnTarget) return
    const mode = this.selectedMode
    let valid = true
    if (mode === "future") {
      const hasDate = this.hasDateInputTarget && this.dateInputTarget.value
      valid = valid && !!hasDate
    }
    if (this.hasFeeCheckboxTarget && this.feeCheckboxTarget.checked) {
      const amount = this.hasFeeAmountInputTarget ? parseFloat(String(this.feeAmountInputTarget.value).replace(/[^0-9.]/g, "")) : 0
      valid = valid && !isNaN(amount) && amount > 0
    }
    this.submitBtnTarget.disabled = !valid
  }

  get selectedMode() {
    if (!this.hasModeRadioTarget) return "now"
    const checked = this.modeRadioTargets.find((el) => el.checked)
    return checked ? checked.value : "now"
  }
}
